// extracted by mini-css-extract-plugin
export default {"container":"Error404_container__D0wo3","content":"Error404_content__26tT2"};